<script setup>
defineProps({
  logo: {
    type: String,
  },
});

const isOpen = defineModel();

/**
 * Toggle the mobile menu open/close state
 */
function toggleMenu() {
  isOpen.value = !isOpen.value;
}

defineExpose({
  toggleMenu,
});
</script>

<template>
  <nav
    class="fixed top-0 left-0 w-full z-50 font-iq-paragraph leading-iq-paragraph tracking-iq-paragraph text-iq-paragraph-color"
  >
    <!-- Backdrop -->
    <transition name="fade">
      <div
        v-if="isOpen"
        class="fixed inset-0 bg-black/50 backdrop-blur-sm"
        @click="toggleMenu"
      />
    </transition>

    <!-- Menu panel -->
    <transition name="slide">
      <aside
        v-if="isOpen"
        class="fixed top-0 left-0 h-full w-64 py-12 bg-white/10 backdrop-blur-lg ring-1 ring-white/20 rounded-r-iq-roundness shadow-xl flex flex-col"
      >
        <div class="flex flex-row items-center justify-between px-6">
          <!-- Name -->
          <NuxtLink
            to="/"
            class="text-2xl font-bold text-white tracking-tight"
            @click="toggleMenu"
          >
            <slot name="logo">{{ logo }}</slot>
          </NuxtLink>

          <button class="self-end p-2" @click="toggleMenu" aria-label="Close menu">
            <!-- X Icon -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 text-white/80"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <ul class="mt-6 space-y-2">
          <li>
            <NuxtLink
              to="/"
              class="block px-6 py-3 bg-white/5 text-lg font-medium text-white active:bg-white/15 transition duration-150"
              active-class="bg-white/15"
              @click="toggleMenu"
            >
              Strona Główna
            </NuxtLink>
          </li>

          <li>
            <NuxtLink
              to="/proces-tworzenia-strony"
              class="block px-6 py-3 bg-white/5 text-lg font-medium text-white active:bg-white/15 transition duration-150"
              active-class="bg-white/15"
              @click="toggleMenu"
            >
              Proces tworzenia strony
            </NuxtLink>
          </li>

          <li>
            <NuxtLink
              to="/cennik"
              class="block px-6 py-3 bg-white/5 text-lg font-medium text-white active:bg-white/15 transition duration-150"
              active-class="bg-white/15"
              @click="toggleMenu"
            >
              Cennik
            </NuxtLink>
          </li>

          <li>
            <NuxtLink
              to="/pomoc"
              class="block px-6 py-3 bg-white/5 text-lg font-medium text-white active:bg-white/15 transition duration-150"
              active-class="bg-white/15"
              @click="toggleMenu"
            >
              Przydatne informacje
            </NuxtLink>
          </li>

          <li>
            <NuxtLink
              to="/kontakt"
              class="block px-6 py-3 bg-white/5 text-lg font-medium text-white active:bg-white/15 transition duration-150"
              active-class="bg-white/15"
              @click="toggleMenu"
            >
              Kontakt
            </NuxtLink>
          </li>
        </ul>

        <div class="mt-auto border-t border-white/20 pt-4 px-6">
          <slot name="footer">
            <a
              href="#"
              class="block text-sm text-white/70 hover:text-white/90 transition"
            >
              © 2025 My Company
            </a>
          </slot>
        </div>
      </aside>
    </transition>
  </nav>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active {
  transition: transform 0.3s ease;
}
.slide-enter-from {
  transform: translateX(-100%);
}
.slide-leave-active {
  transition: transform 0.2s ease;
}
.slide-leave-to {
  transform: translateX(-100%);
}
</style>
